/**
 * @flow
 * @relayHash 7aeaa5f4ae6065b271193b6580019ab5
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type FollowingsShownMutationVariables = {|
  input: {
    ids: $ReadOnlyArray<?string>;
    clientMutationId?: ?string;
  };
|};

export type FollowingsShownMutationResponse = {|
  +followingsShown: ?{|
    +clientMutationId: ?string;
  |};
|};
*/


/*
mutation FollowingsShownMutation(
  $input: FollowingsShownInput!
) {
  followingsShown(input: $input) {
    clientMutationId
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "FollowingsShownInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FollowingsShownMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "FollowingsShownInput!"
          }
        ],
        "concreteType": "FollowingsShownPayload",
        "name": "followingsShown",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "FollowingsShownMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "FollowingsShownInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "FollowingsShownMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "FollowingsShownInput!"
          }
        ],
        "concreteType": "FollowingsShownPayload",
        "name": "followingsShown",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation FollowingsShownMutation(\n  $input: FollowingsShownInput!\n) {\n  followingsShown(input: $input) {\n    clientMutationId\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/components/FavNotifications/__generated__/FollowingsShownMutation.graphql.js